import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-determine",
  "use": "icon-icon-determine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-determine\"><path d=\"M409.31328 790.44608a39.69024 39.69024 0 0 1-28.2112-11.68384L107.85792 505.51808a39.936 39.936 0 1 1 56.43264-56.43264l245.0432 245.0432 449.95584-449.98656a39.936 39.936 0 1 1 56.43264 56.43264l-478.208 478.208a39.58784 39.58784 0 0 1-28.2112 11.68384z m0 0\" fill=\"#1F91F2\" p-id=\"2934\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol